export default {
    targetSetAssessment: {
        defaults: {
            rootProperty: 'sub_categories',
            endpoint: 'targetSetV.php' // scope: target_set_id=14
        },
        read: {
            params: {
                action: 'get',
                property: 'sub_categories'
            }
        },
        create: {
            params: {
                action: 'create',
                property: 'sub_categories'
            }
        },
        update: {
            params: {
                action: 'update',
                property: 'sub_categories'
            }
        },
        destroy: {
            params: {
                action: 'delete',
                property: 'sub_categories'
            }
        }
    }
}